<template>
    <Screen>
        <AppBar :title="title" />
        <Breadcrumbs
            :links="[
                {
                    to: $route('admin.blissdom.categories.index'),
                    title: 'Blissdom categories',
                },
            ]"
            :title="title"
        />
        <div class="card card-body" v-if="formSet">
            <div class="row">
                <div class="col-lg-6">
                    <h4>Details</h4>
                    <hr />
                    <form
                        action=""
                        method="post"
                        @submit.prevent="submit"
                        v-if="formSet"
                    >
                        <TextBox
                            name="name"
                            v-model="form.name"
                            :disabled="form.processing"
                            :error="form.errors.name"
                        />
                        <TextBox
                            name="sort_order"
                            v-model="form.sort_order"
                            :disabled="form.processing"
                            :error="form.errors.sort_order"
                            helperText="Higher the number, higher the priority"
                        />
                        <FileInput
                            name="icon"
                            v-model="form.icon"
                            :fileUrl="form.icon_url"
                            :disabled="form.processing"
                            :error="form.errors.icon"
                            helperText="Ideal size is 120x120 pixels or aspect ratio of 1:1. Upload svg file for better quality"
                        />
                        <div class="row">
                            <div class="col-auto">
                                <StatusRadio
                                    v-model="form.isactive"
                                    :disabled="form.processing"
                                    :error="form.errors.isactive"
                                />
                            </div>
                            <div class="col-auto">
                                <StatusRadio
                                    label="Premium content"
                                    :radioLabel="['Yes', 'No']"
                                    name="premium_only"
                                    v-model="form.premium_only"
                                    :disabled="form.processing"
                                    :error="form.errors.premium_only"
                                />
                            </div>
                        </div>
                        <div class="mt-4 text-center">
                            <button
                                class="btn btn-primary w-25"
                                type="submit"
                                :disabled="form.processing"
                                @click.prevent="submit"
                            >
                                <div
                                    class="spinner-border spinner-border-sm"
                                    role="status"
                                    v-if="form.processing"
                                ></div>
                                <span v-else>Save</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </Screen>
</template>
<script>
import FileInput from "@/components/form/fileInput.vue";

export default {
    components: {
        FileInput,
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        formData: {
            type: [Object, Array],
            default: () => {},
        },
        submitUrl: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            form: {},
            formSet: false,
        };
    },
    mounted() {
        setTimeout(() => {
            this.form = this.$inertia.form(this.formData);
            this.form.icon = null;

            setTimeout(() => {
                this.formSet = true;
            });
        });
    },
    methods: {
        submit() {
            this.form.post(this.submitUrl);
        },
    },
    computed: {
        showContent() {
            const exclude = ["breathing-exercise", "meditation-tracks"];
            if (exclude.includes(this.form.content_type)) {
                return false;
            }
            return true;
        },
    },
};
</script>
<style lang="scss" scoped>
.content-type-help {
    padding: 1rem;
    border: 2px solid var(--warning);
    border-radius: var(--border-radius);
    margin-bottom: 1rem;
}
</style>
